import type { Catalogue } from "../../types/catalogue.types";

export type CatalogueKind = "STOCK_IN" | "STOCK_OUT";

export function catalogueKindOf(value: unknown): CatalogueKind | undefined {
  const raw = String(value || "").toUpperCase();
  if (raw === "STOCK_IN" || raw === "STOCK_OUT") {
    return raw;
  }
  return undefined;
}

export function isSystemManagedCatalogue(
  catalogue: {
    systemManaged?: boolean;
    catalogueKind?: string;
  } | null | undefined
): boolean {
  if (!catalogue) {
    return false;
  }
  return Boolean(catalogue.systemManaged) || Boolean(catalogueKindOf(catalogue.catalogueKind));
}

export function catalogueDisplayName(catalogue: {
  name?: string;
  catalogueKind?: string;
}): string {
  const kind = catalogueKindOf(catalogue.catalogueKind);
  if (kind === "STOCK_IN") {
    return "In stock sarees";
  }
  if (kind === "STOCK_OUT") {
    return "Out of stock";
  }
  return String(catalogue.name || "").trim();
}

export function mapStudioCatalogueFromApi(doc: any, fallbackId = ""): Catalogue {
  const kind = catalogueKindOf(doc?.catalogueKind);
  const systemManaged =
    Boolean(doc?.systemManaged ?? doc?.isSystemManaged) || Boolean(kind);
  const createdAt = doc?.createdAt;
  return {
    id: String(doc?._id || doc?.id || fallbackId),
    name: catalogueDisplayName({ name: doc?.name, catalogueKind: kind }),
    description: doc?.description,
    category: doc?.category || "",
    targetMarket: doc?.targetMarket || "",
    sharedLinks: Array.isArray(doc?.sharedLinks) ? doc.sharedLinks : [],
    products: Number(doc?.productCount ?? doc?.totalProducts ?? doc?.products ?? 0) || 0,
    created: createdAt
      ? new Date(createdAt).toLocaleDateString("en-IN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
      : "",
    createdTime: createdAt
      ? new Date(createdAt).toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : "",
    shared: Number(
      doc?.shareLinkCount ?? (Array.isArray(doc?.sharedLinks) ? doc.sharedLinks.length : 0)
    ),
    accessed: Number(
      doc?.inviteeViewCount ?? doc?.viewCount ?? 0
    ),
    status: doc?.active || doc?.isActive ? "active" : "inactive",
    systemManaged,
    catalogueKind: kind,
    sharingMode: sharingModeOf(doc?.sharingMode),
  };
}

function sharingModeOf(raw: unknown): Catalogue["sharingMode"] {
  const v = String(raw || "").trim().toUpperCase();
  return v === "RESELLER" || v === "OPEN" ? v : "EXCLUSIVE";
}
